import picture from './images/profile.png'
import icons from './images/document-download.png'
import upred from './images/trending-upred.svg'
import ugreen from './images/trending-upgreen.svg'
import trendred from './images/3red.svg'
import trendgreen from './images/3green.svg'
import order from './images/box-tick.svg'
import refund from './images/3d-rotate.svg'
import sales from './images/shopping-cart.svg'
import income from './images/coin.svg'


export const Daily = [
    {
        id: 1,
        day: 'Day 01',
        userGain: 6000,
    },
    {
        id: 2,
        day: 'Day 02',
        userGain: 20000,
    },
    {
        id: 3,
        day: 'Day 03',
        userGain: 3500,
    },
    {
        id: 4,
        day: 'Day 04',
        userGain: 27000,
    },
    {
        id: 5,
        day: 'Day 05',
        userGain: 9000,
    },
    {
        id: 6,
        day: 'Day 06',
        userGain: 45000,
    },
    {
        id: 7,
        day: 'Day 07',
        userGain: 9000,
    },
    {
        id: 8,
        day: 'Day 08',
        userGain: 27000,
    },
    {
        id: 9,
        day: 'Day 09',
        userGain: 33000,
    },
    {
        id: 10,
        day: 'Day 10',
        userGain: 4000,
    },
    {
        id: 11,
        day: 'Day 11',
        userGain: 30000,
    },
    {
        id: 12,
        day: 'Day 12',
        userGain: 26000,
    }
]

export const Weekly = [
    {
        id: 1,
        week: 'Wk 01',
        userGain: 35000,
    },
    {
        id: 2,
        week: 'Wk 02',
        userGain: 20000,
    },
    {
        id: 3,
        week: 'Wk 03',
        userGain: 45000,
    },
    {
        id: 4,
        week: 'Wk 04',
        userGain: 27000,
    },
    {
        id: 5,
        week: 'Wk 05',
        userGain: 40000,
    },
    {
        id: 6,
        week: 'Wk 06',
        userGain: 35000,
    },
    {
        id: 7,
        week: 'Wk 07',
        userGain: 39000,
    },
    {
        id: 8,
        week: 'Wk 08',
        userGain: 27000,
    },
    {
        id: 9,
        week: 'Wk 09',
        userGain: 33000,
    },
    {
        id: 10,
        week: 'Wk 10',
        userGain: 9000,
    },
    {
        id: 11,
        week: 'Wk 11',
        userGain: 30000,
    },
    {
        id: 12,
        week: 'Wk 12',
        userGain: 26000,
    }
]

export const Monthly = [
    {
        id: 1,
        month: 'Jan',
        userGain: 30000,
    },
    {
        id: 2,
        month: 'Feb',
        userGain: 20000,
    },
    {
        id: 3,
        month: 'Mar',
        userGain: 35000,
    },
    {
        id: 4,
        month: 'Apr',
        userGain: 27000,
    },
    {
        id: 5,
        month: 'May',
        userGain: 5000,
    },
    {
        id: 6,
        month: 'Jun',
        userGain: 5000,
    },
    {
        id: 7,
        month: 'Jul',
        userGain: 9000,
    },
    {
        id: 8,
        month: 'Aug',
        userGain: 37000,
    },
    {
        id: 9,
        month: 'Sep',
        userGain: 35000,
    },
    {
        id: 10,
        month: 'Oct',
        userGain: 44000,
    },
    {
        id: 11,
        month: 'Nov',
        userGain: 30000,
    },
    {
        id: 12,
        month: 'Dec',
        userGain: 45000,
    }
]

export const Yearly = [
    {
        id: 1,
        year: 2013,
        userGain: 20000,
    },
    {
        id: 2,
        year: 2014,
        userGain: 12000,
    },
    {
        id: 3,
        year: 2015,
        userGain: 6000,
    },
    {
        id: 4,
        year: 2016,
        userGain: 23000,
    },
    {
        id: 5,
        year: 2017,
        userGain: 19000,
    },
    {
        id: 6,
        year: 2018,
        userGain: 3000,
    },
    {
        id: 7,
        year: 2019,
        userGain: 10000,
    },
    {
        id: 8,
        year: 2020,
        userGain: 27000,
    },
    {
        id: 9,
        year: 2021,
        userGain: 45000,
    },
    {
        id: 10,
        year: 2022,
        userGain: 40000,
    },
    {
        id: 11,
        year: 2023,
        userGain: 30000,
    },
    {
        id: 12,
        year: 2024,
        userGain: 40000,
    }
]

export const Users = [
    {
        id: 1,
        img: picture,
        name: "David David",
        date: "Nov 15, 2023",
        amount: "$10,000",
        status: "Paid",
        icon: icons,
        invoice: "View"
    },
    {
        id: 2,
        img: picture,
        name: "David David",
        date: "Nov 15, 2023",
        amount: "$10,000",
        status: "Refund",
        icon: icons,
        invoice: "View"
    },
    {
        id: 3,
        img: picture,
        name: "David David",
        date: "Nov 15, 2023",
        amount: "$10,000",
        status: "Pending",
        icon: icons,
        invoice: "View"
    },
    {
        id: 4,
        img: picture,
        name: "David David",
        date: "Nov 15, 2023",
        amount: "$10,000",
        status: "Failed",
        icon: icons,
        invoice: "View"
    },
    {
        id: 5,
        img: picture,
        name: "David David",
        date: "Nov 15, 2023",
        amount: "$10,000",
        status: "Paid",
        icon: icons,
        invoice: "View"
    }
]

export const Analytic = [
    {
        id: 1,
        icon: order,
        img: trendgreen,
        text: 'Total Order',
        amount: 350,
        percent: '25.5%',
        arrow: ugreen,
        text2: 'vs. previous month'
    },
    {
        id: 2,
        icon: refund,
        img: trendred,
        text: 'Total Refund',
        amount: 270,
        percent: '25.5%',
        arrow: upred,
        text2: 'vs. previous month'
    },
    {
        id: 3,
        icon: sales,
        img: trendred,
        text: 'Average Sales',
        amount: 1567,
        percent: '25.5%',
        arrow: upred,
        text2: 'vs. previous month'
    },
    {
        id: 4,
        icon: income,
        img: trendgreen,
        text: 'Total Income',
        amount: 350000,
        percent: '25.5%',
        arrow: ugreen,
        text2: 'vs. previous month'
    }
]

export const Platforms = [
    {
        id: 1,
        name: 'Book Bazaar',
        price: 2500000,
        percent: 15
    },
    {
        id: 2,
        name: 'Artisan Aisle',
        price: 1800000,
        percent: 10
    },
    {
        id: 3,
        name: 'Tat Troop',
        price: 1200000,
        percent: 8
    },
    {
        id: 4,
        name: 'XStore',
        price: 800000,
        percent: 6
    }
]

export const Options = {
    aspectRatio: 4/3
}